import { Data } from '../signup-data/DATA';
import { getQueryParam } from './getQueryParam';
export const getIsPostVerification = () => {
  const tokenQueryParam = getQueryParam(Data.Token.toLowerCase());
  return Boolean(tokenQueryParam);
};